export const arrayLengthDivision = (array: any[]): number => {
  return array.length === 0 ? 1 : array.length;
};
